import React from 'react';
import PropTypes from 'prop-types';
import { compose, withState, withHandlers, lifecycle } from 'recompose';
import { connect } from 'react-redux';

import authHOC from '../Components/AuthHOC';
import LoginView from './Components/LoginView';

import { authAdminRequest, authUserRequest, getTokenFromCookies, loginAdminRequest, loginReset } from '../redux/reducers/login';
import { API_DONT_SHOW_TUTORIAL_SUCCESS } from '../redux/reducers/tutorial';

import { resetDeactivate } from '../redux/reducers/deactivate';
import Notification from '../Components/Popups/Notification';

import {
  getTeamMembersFullRequest,
  getTeamMembersFullSuccess,
  getTeamMembersFullFailure,
  selectTeamMember,
  selectThinkTool,
} from '../redux/reducers/teamMembersFull';


const Login = ({
  isShowLogin,
  showRegistrationPopup,
  showForgottenPopup,
  handlePopupToggle,
  handleForgottenPopup,
  handleRegistrationPopup,
  isDeactivated
}) => (
  <div>
  <LoginView
    isShowLogin={isShowLogin}
    showRegistrationPopup={showRegistrationPopup}
    showForgottenPopup={showForgottenPopup}
    handlePopupToggle={handlePopupToggle}
    handleForgottenPopup={handleForgottenPopup}
    handleRegistrationPopup={handleRegistrationPopup}
    isDeactivated={isDeactivated}
  />
  </div>

);

const mapStateToProps = state => ({
  loginReducer: state.loginReducer,
  isDeactivated: state.DeactivateReducer.isDeactivated,
  coachFull: state.teamMembersFullReducer,
});

const mapDispatchToProps = dispatch => ({
  getToken: token => dispatch(getTokenFromCookies(token)),
  authUser: () => dispatch(authUserRequest()),
  authAdmin: (obj) => dispatch(authAdminRequest(obj)),
  loginReset: () => dispatch(loginReset()),
  loginAdminRequest: (obj) => dispatch(loginAdminRequest(obj)),
  authAdmin: (obj) => dispatch(authAdminRequest(obj)),
  resetDeactivated: () => dispatch(resetDeactivated()),
  getTeamMembersFullRequest: () => dispatch(getTeamMembersFullRequest()),
});

export default compose(
  withState('isShowLogin', 'toggleLogin', true),
  withState('showForgottenPopup', 'toggleForgottenPopup', false),
  withState('showRegistrationPopup', 'toggleRegistrationPopup', false),
  withState('resetSuccessMessageDone', 'handleResetSuccessMessage', false),
  withHandlers({
    handlePopupToggle: props => event => {
      event.preventDefault();
      props.toggleForgottenPopup(false);
      props.toggleRegistrationPopup(false);
      props.toggleLogin(!props.isShowLogin);
    },
    handleForgottenPopup: props => event => {
      event.preventDefault();
      props.toggleLogin(!props.isShowLogin);
      props.toggleForgottenPopup(!props.showForgottenPopup);
    },
    handleRegistrationPopup: props => event => {
      event.preventDefault();
      props.toggleLogin(false);
      props.toggleForgottenPopup(false);
      props.toggleRegistrationPopup(true);
    },
    
  }),
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  authHOC,
  lifecycle({
    componentWillMount() {
      
      const { history, loginReducer } = this.props;
      if (loginReducer.isLoggedIn && !loginReducer.error) {
        history.replace('/team-leader'+ history.location.search);
      }
    //  this.props.loginAdminRequest({userId:'1044', firstName:'shaun', lastName:'test',email:'shuans', avatar:'', numberOfUnreadMessages:'0'})
        
    },
    componentWillReceiveProps(nextProps) {
      const { history, loginReducer } = nextProps;
      
      if (loginReducer.isLoggedIn && !loginReducer.error) {
        //if (loginReducer.user.isTeamLeader) {
          history.replace('/team-leader'+ history.location.search);
        // } else {
        
        //   history.replace('/learner');
        // }
      }
    },
    componentWillUnmount() {
      clearTimeout(this.props.timer);
    },
  }),
)(Login);

Login.propTypes = {
  showForgottenPopup: PropTypes.bool,
  showRegistrationPopup: PropTypes.bool,
  isShowLogin: PropTypes.bool,
  handlePopupToggle: PropTypes.func,
  handleForgottenPopup: PropTypes.func,
  handleRegistrationPopup: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/Screens/Login.jsx